import request, { FormDataHeader } from '@/utils/request'
import { GetUserWxBindInfoResult, UserSubscribeType } from '@/types/wx-bind'
// 获取用户绑定消息
export function getUserWxBindInfo(): Promise<GetUserWxBindInfoResult> {
  return request.get('/api/applets/user/info')
}

// 订阅维修服务进度
export function requestSubscribeService(type: UserSubscribeType): Promise<void> {
  return request.get(`/api/applets/user/subscribe?type=${type}`)
}
// 取消订阅维修服务进度
export function requestUnSubscribeService(type: UserSubscribeType): Promise<void> {
  return request.get(`/api/applets/user/unsubscribe?type=${type}`)
}
// 解绑操作
export function requestUnbindService(): Promise<void> {
  return request.post(
    '/api-account/wechat/oauth/unbind',
    {
      type: 'service',
    },
    {
      headers: {
        ...FormDataHeader,
        Authorization: 'Basic NTY6ZjIwOTE3MTFjNmRhMDQwNWQxNTMwYzU2ODZkNjEzNWIg',
      },
    }
  )
}
